import {
  Cancel as CancelIcon,
  CloudDownload as DownloadIcon,
  PhotoSizeSelectActual as FullSizeIcon,
  PhotoSizeSelectSmall as SmallIcon,
  PhotoSizeSelectLarge as WwwIcon,
} from "@mui/icons-material";
import { Fab as FloatingActionButton, SpeedDial, SpeedDialAction, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { useDownloadImages } from "../misc/useDownloadImages";
import type { MediaImage } from "./mediaApi";

interface Props {
  readonly selectedImages: MediaImage[] | null;
  onStartSelection: () => void;
  onClearSelection: () => void;
}

const DownloadImages: FC<Props> = ({ selectedImages, onStartSelection, onClearSelection }) => {
  const { download } = useDownloadImages();

  const handleDownload = async (imageSize: "original" | "www" | "thumbnail") => {
    if (!selectedImages) {
      return;
    }
    await download(
      selectedImages.map((i) => ({ name: i.name, url: i[imageSize].url, source: i.source, info: i.info })),
      { zipFileName: `images_${imageSize}.zip` },
    );
    onClearSelection();
  };

  if (selectedImages === null) {
    return (
      <FloatingActionButton color="secondary" title="Wybierz grafiki" onClick={onStartSelection}>
        <DownloadIcon />
      </FloatingActionButton>
    );
  }
  return (
    <Stack
      direction="row"
      spacing={3}
      sx={{
        alignItems: "end",
      }}
    >
      <Typography variant="body2">Zaznaczono: {selectedImages.length}</Typography>
      <FloatingActionButton color="secondary" title="Anuluj" onClick={onClearSelection}>
        <CancelIcon />
      </FloatingActionButton>
      {selectedImages.length > 0 ? (
        <SpeedDial color="secondary" title="Pobierz" icon={<DownloadIcon />} ariaLabel="Pobierz zdjęcia">
          <SpeedDialAction
            key="full-size"
            icon={<FullSizeIcon />}
            onClick={() => handleDownload("original")}
            slotProps={{
              tooltip: {
                title: "Pełny rozmiar",
              },
            }}
          />
          <SpeedDialAction
            key="www-size"
            icon={<WwwIcon />}
            onClick={() => handleDownload("www")}
            slotProps={{
              tooltip: {
                title: "Rozmiar WWW",
              },
            }}
          />
          <SpeedDialAction
            key="thumbnail-size"
            icon={<SmallIcon />}
            onClick={() => handleDownload("thumbnail")}
            slotProps={{
              tooltip: {
                title: "Miniaturki",
              },
            }}
          />
        </SpeedDial>
      ) : (
        <FloatingActionButton title="Pobierz zdjęcia" disabled>
          <DownloadIcon />
        </FloatingActionButton>
      )}
    </Stack>
  );
};

export default DownloadImages;
